import dayjs from 'dayjs'

export const getBlogPostingSchema = ({
  title,
  author,
  datePublished,
  dateModified,
  summary,
  imageURL,
}) => {
  validateDate(datePublished, title, 'datePublished')
  if (dateModified) {
    validateDate(dateModified, title, 'dateModified')
  }

  return {
    '@context': 'https://schema.org/',
    '@type': 'BlogPosting',
    // it's unclear if 'name' or ;headline' is the correct property to use,
    // so let's set both
    name: title,
    headline: title,
    author: {
      '@type': 'Person',
      name: author?.name,
    },
    datePublished,
    dateModified: dateModified || datePublished,
    description: summary.plainText,
    image: imageURL,
  }
}

function validateDate (date, title, dateName) {
  const dayjsDate = dayjs(date)
  if (!dayjsDate.isValid()) {
    throw new Error(`Invalid ${dateName} "${date}" for blog post "${title}"`)
  }
}
